import React from "react";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {
    hasUnsavedLeadSettingsChangesSelector,
    resetLeadSettings,
    updateLeadSettings,
    updateLeadSettingsStatusSelector
} from "./leadsSlice";
import {showErrorToastNotification, showSuccessToastNotification} from "../../../../elements/toastNotification/toastNotificationSlice";
import {fetchBotById} from "../../botSlice";
import {FullBotUi} from "../../../../../api/generated";
import {useUnsavedChangesWarning} from "../../../../../hooks/useUnsavedChangesWarning";
import {LeadsForm} from "./LeadsForm";

interface LeadsTabProps {
    bot: FullBotUi;
}

export const LeadsTab: React.FC<LeadsTabProps> = ({bot}) => {
    const dispatch = useAppDispatch();
    const hasUnsavedChanges = useAppSelector(hasUnsavedLeadSettingsChangesSelector);
    const updateStatus = useAppSelector(updateLeadSettingsStatusSelector);

    useUnsavedChangesWarning(hasUnsavedChanges);

    const handleSave = async () => {
        try {
            await dispatch(updateLeadSettings(bot.publicId)).unwrap();
            dispatch(showSuccessToastNotification({message: "Lead settings updated successfully"}));
            dispatch(fetchBotById(bot.publicId));
        } catch (error) {
            dispatch(showErrorToastNotification({message: "Failed to update lead settings"}));
        }
    };

    const handleDiscard = () => {
        dispatch(resetLeadSettings());
    };

    return <LeadsForm
        hasUnsavedChanges={hasUnsavedChanges}
        updateStatus={updateStatus}
        onSave={handleSave}
        onDiscard={handleDiscard}
    />
}
